// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jd-detail-body[data-v-2a7838e8]{padding:20px}.jd-detail-body .label[data-v-2a7838e8]{color:#303133;font-size:18px;font-weight:700}.jd-detail-body .normal[data-v-2a7838e8]{color:#606266;font-size:14px;line-height:2.5em;white-space:pre-line}.jd-detail-body .jd-link[data-v-2a7838e8]{font-size:14px;margin-right:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
